import { render, staticRenderFns } from "./examPage.vue?vue&type=template&id=c4ae1376"
import script from "./examPage.vue?vue&type=script&lang=js"
export * from "./examPage.vue?vue&type=script&lang=js"
import style0 from "./examPage.vue?vue&type=style&index=0&id=c4ae1376&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports